import React from 'react';

import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import MapIcon from '@mui/icons-material/Map';

import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

// import { useResponsive } from '../hooks/useResponsive';
import { LanguageSelector } from './LanguageSelector';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const NavBar = () => {
  const { t } = useTranslation();

  const pages = [
    { label: t('navbar.welcome'), path: '/' },
    { label: t('navbar.explore'), path: '/explore' },
  ];
  const publicUrl = (path) => {
    return `${PUBLIC_URL}${path}`;
  };
  const navigate = useNavigate();
  // const { isMobile } = useResponsive();

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleChangeRoute = (path) => {
    navigate(publicUrl(path));
  };

  const style = {
    buttonMobileContainer: {
      display: { xs: 'flex', md: 'none' },
      alignItems: 'center',
    },
    titleTypo: {
      mr: 2,
      display: { xs: 'none', md: 'flex' },
      flexGrow: 1,
      fontWeight: 700,
      letterSpacing: '.3rem',
      color: 'inherit',
      textDecoration: 'none',
    },
    mapIcon: { display: { xs: 'flex', md: 'none' }, mr: 1 },
    titleMobileTypo: {
      mr: 2,
      display: { xs: 'flex', md: 'none' },
      flexGrow: 1,
      fontFamily: 'monospace',
      fontWeight: 700,
      fontSize: '1.5em',
      letterSpacing: '.3rem',
      color: 'inherit',
      textDecoration: 'none',
    },
    buttonContainer: {
      display: { xs: 'none', md: 'flex' },
      alignItems: 'center',
      paddingY: 2,
      gap: 3,
    },
    routeButton: {
      color: 'white',
      display: 'flex',
      '&: hover': {
        textDecoration: 'underline',
      },
    },
  };

  return (
    <AppBar position='static'>
      <Container maxWidth='full'>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
          disableGutters
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <MapIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
            <Typography
              variant='h6'
              noWrap
              component='a'
              href={publicUrl('/')}
              sx={style.titleTypo}
            >
              {t('navbar.title')}
            </Typography>
          </Box>
          <MapIcon sx={style.mapIcon} />
          <Typography
            variant='h5'
            noWrap
            component='a'
            href=''
            sx={style.titleMobileTypo}
          >
            {t('navbar.title')}
          </Typography>
          <Box sx={style.buttonContainer}>
            {pages.map((page, index) => (
              <React.Fragment key={index}>
                <Button
                  onClick={() => handleChangeRoute(page.path)}
                  sx={style.routeButton}
                >
                  {page.label}
                </Button>
                <Divider
                  orientation='vertical'
                  flexItem
                  sx={{ backgroundColor: '#FFFFFF' }}
                />
              </React.Fragment>
            ))}
            <LanguageSelector />
          </Box>
          <Box sx={style.buttonMobileContainer}>
            <IconButton
              size='large'
              aria-label='menu-page'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page, index) => (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleChangeRoute(page.path);
                    handleCloseNavMenu();
                  }}
                >
                  <Typography textAlign='center'>{page.label}</Typography>
                </MenuItem>
              ))}
            </Menu>
            <LanguageSelector />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
